<template>
  <div class="rt-button-list">
    <div
      v-if="$slots.primary && isSave"
      class="__primary"
    >
      <slot name="primary" />
    </div>
    <div
      v-if="!$slots.primary && isSave"
      class="__primary"
    >
      <rt-button
        icon-name="rt-base-circle-check-lined"
        color-type="primary"
        @click="save"
      >
        {{ primaryName }}
      </rt-button>
    </div>
    <rt-header-button-group :max-btns="maxBtns">
      <slot />
    </rt-header-button-group>
    <div
      v-if="isBack"
      class="__back"
    >
      <rt-button
        icon-name="rt-base-back"
        @click="back"
      >
        {{ $tx('返回', 'xpc.detailheader.back') }}
      </rt-button>
    </div>
  </div>
</template>

<script>
import RtButton from './rtButton';
import RtHeaderButtonGroup from '../business/common/rtHeaderButtonGroup.vue';

export default {
  name: 'RtButtonList',
  components: { RtHeaderButtonGroup, RtButton },
  props: {
    maxBtns: {
      type: Number,
      default: 3
    },
    isBack: {
      type: Boolean,
      default: true
    },
    primaryName: {
      type: String,
      default () {
        return this.$tx('主要', 'xpc.common.main');
      }
    },
    isSave: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    back () {
      if (this.isBack) {
        this.$router.back();
        return;
      }
      this.$emit('back');
    },
    save () {
      this.$emit('save');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtButtonList.vue?7d88b540